/** Importo scritto all'italiana («1.234,56») o all'inglese («1234.56») → stringa decimale per l'API. */
export function normalizeAmountInput(raw: string): string | null {
  const text = raw.trim().replace(/\s|€/g, '');
  if (!text) return null;
  // Con la virgola, i punti sono separatori delle migliaia.
  const normalized = text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text;
  return /^\d{1,14}(\.\d{1,4})?$/.test(normalized) ? normalized : null;
}
